import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinusCircled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 498C0 830 190 1000 500 1000C810 1000 1000 830 1000 498C1000 191 810 0 500 0C190 0 0 191 0 498ZM82 558V438C82 235 260 74 500 74C740 74 918 235 918 438V558C918 771 764 926 500 926C236 926 82 771 82 558ZM258 536V464H742V536Z" })
});
export default SvgMinusCircled;
